export function CommaEncodeChar(c) {
  var s;
  switch (c) {
    case ",":
      s = "&com;";
      break;
    default:
      s = c;
      break;
  }

  return s;
}
